import React from 'react';
import { useNavigate } from 'react-router-dom';

import { segmentsRouteCreatorFactory } from '@occc/feat-segments/segments.router';
import { useConfig } from '@occc/config';

import { SegmentForMembershipFilter } from '@occc/graphql';
import { Segment } from '@occc/feat-segments';
import Segments from './Segments';
import { useGetSegmentsByMembershipUuid } from '../../../../../../dataAccessLayer/membership/queries';

export interface SegmentsContainerContainerProps {
  memberId: string;
}

export const SegmentsContainer: React.FC<SegmentsContainerContainerProps> = ({ memberId }) => {
  const { version } = useConfig('features.segments');
  const { routeCreator: segmentsRouteCreator } = segmentsRouteCreatorFactory(version);
  const navigate = useNavigate();
  const onSegmentsClick = (uuid: string) => {
    navigate(segmentsRouteCreator.details(uuid));
  };

  const filter: SegmentForMembershipFilter = {
    membershipUuid: memberId,
  };

  const { loading, error, data, paginationProps } = useGetSegmentsByMembershipUuid({ filter });

  const segments = data.map<Segment>(({ id, membershipSegmentCreatedAt, ...rest }) => ({
    uuid: id,
    createdAt: membershipSegmentCreatedAt || '',
    ...rest,
  }));

  return (
    <Segments
      segments={segments}
      error={error}
      loading={loading}
      paginationProps={paginationProps}
      onSegmentsClick={onSegmentsClick}
    />
  );
};
